import type { Theme } from '../../types/theme';

export const composioTheme: Theme = {
  id: 'composio',
  name: 'Composio',
  description: 'Modern dark with colorful integration icons for tool platform',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/composio/DESIGN.md',
  visualKeywords: ['dark', 'purple', 'colorful icons', 'tool integration', 'modern'],
  colors: {
    background: '#0f0f23',
    surface: '#1a1a2e',
    surfaceElevated: '#242438',
    textPrimary: '#ffffff',
    textSecondary: '#a0a0c0',
    textMuted: '#a0a0c0',
    border: '#2d2d4a',
    borderSubtle: '#373754',
    primary: '#8b5cf6',
    primaryHover: '#9a6bff',
    primaryActive: '#6d3ed8',
    accent: '#8b5cf6',
    onPrimary: '#ffffff',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'medium',
    tone: 'modern',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
